module.exports = __webpack_public_path__ + "7eedd262d94df1e9a5d71121d98c1441.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/175.png
// module id = 1762
// module chunks = 2